/**
 * Instrucao — narracao em audio + legenda na tela.
 *
 * D5 (inviolavel): nenhuma instrucao apenas por texto. Sempre narracao em audio
 * + demonstracao visual. O texto aparece junto, para treinar leitura, mas
 * NUNCA sozinho.
 *
 * Enquanto os audios nao existirem, este modulo mostra a legenda E registra um
 * aviso alto no console dizendo que D5 nao esta cumprida. O jogo roda para dar
 * para testar a mecanica, mas nao esta pronto para as criancas.
 */

let estiloInjetado = false;

function injetarEstilo() {
  if (estiloInjetado) return;
  estiloInjetado = true;

  const estilo = document.createElement('style');
  estilo.textContent = `
    .instrucao {
      position: fixed;
      left: 50%;
      bottom: 40px;
      transform: translateX(-50%) translateY(20px);
      max-width: min(80vw, 760px);
      padding: 22px 34px;
      border-radius: 28px;
      background: rgba(255, 255, 255, 0.94);
      color: #33372c;
      font-family: system-ui, -apple-system, sans-serif;
      font-size: 34px;
      font-weight: 600;
      line-height: 1.35;
      text-align: center;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
      opacity: 0;
      pointer-events: none;
      transition: opacity 220ms ease, transform 220ms ease;
      z-index: 9;
    }
    .instrucao--visivel {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
    /* Palavra sendo lida em voz alta, para acompanhar com o olho. */
    .instrucao b {
      color: #2e7d32;
      font-weight: 800;
    }
    .instrucao__contador {
      display: block;
      margin-top: 10px;
      font-size: 64px;
      font-weight: 800;
      color: #2e7d32;
    }
  `;
  document.head.appendChild(estilo);
}

export class Instrucao {
  constructor(audioManager) {
    injetarEstilo();
    this.audio = audioManager;

    this.elemento = document.createElement('div');
    this.elemento.className = 'instrucao';
    this.elemento.setAttribute('role', 'status');
    this.elemento.setAttribute('aria-live', 'polite');
    document.body.appendChild(this.elemento);

    this.contador = null;
  }

  /**
   * Mostra a instrucao: toca o audio e exibe a legenda ao mesmo tempo.
   * @param {string} id  id da narracao
   * @param {object} narracao  { texto, audio } vindo do narracao.json
   */
  async mostrar(id, narracao) {
    const texto = narracao?.texto;

    if (!texto && !narracao?.audio) {
      console.warn(
        `FAZENDA: a narracao "${id}" nao tem nem texto nem audio. ` +
          'A crianca vai ver a tarefa sem nenhuma instrucao. ' +
          'Preencha conteudo/narracao.json antes de testar com as criancas.'
      );
    }

    this.elemento.textContent = texto ?? '';
    this.elemento.classList.add('instrucao--visivel');

    // O audio toca junto da legenda, nunca depois.
    await this.audio.narrar(id, narracao);
  }

  /** Mostra um texto avulso (usado no fim de sessao, nao em tarefa). */
  mostrarTexto(texto) {
    this.elemento.textContent = texto;
    this.elemento.classList.add('instrucao--visivel');
  }

  /**
   * D13 — escada concreto -> figura -> simbolo.
   * O numeral so aparece quando a banda permite (mostra_numeral: true).
   */
  mostrarNumeral(numero) {
    if (!this.contador) {
      this.contador = document.createElement('span');
      this.contador.className = 'instrucao__contador';
      this.elemento.appendChild(this.contador);
    }
    this.contador.textContent = String(numero);
  }

  limparNumeral() {
    if (this.contador) {
      this.contador.remove();
      this.contador = null;
    }
  }

  esconder() {
    this.elemento.classList.remove('instrucao--visivel');
    this.limparNumeral();
  }

  descartar() {
    this.elemento.remove();
  }
}
